export enum EmployeeRole {
  CONSULTANT = 'CONSULTANT',
  HR = 'HR',
  GROUP_LEADER = 'GROUP_LEADER',
  DEALER = 'DEALER',
  DIRECTOR = 'DIRECTOR'
}
